export default "__VITE_ASSET__C60BVf0J__$_#icon-Vector-above-right-24__"